import { ExportCsv } from '@material-table/exporters';

import { isUndefined } from './isDefined';

const exportTableDataCsv = async ({
  dataManager,
  fetchData,
  csvHeaders,
  filename,
  mapData
}) => {
  const exportQuery = {
    page: 0,
    pageSize: 1000,
    search: dataManager.searchText || '',
    filters: dataManager.columns
      .filter(col => col.tableData && col.tableData.filterValue !== undefined)
      .map(col => ({ column: col, value: col.tableData.filterValue })),
    orderBy:
      dataManager.orderBy >= 0
        ? dataManager.columns[dataManager.orderBy]
        : undefined,
    orderDirection: dataManager.orderDirection || ''
  };

  const firstResponse = await fetchData({ query: exportQuery });

  if (isUndefined(firstResponse?.data)) {
    return;
  }

  let allData = firstResponse.data;
  const totalCount = firstResponse.totalCount ?? 0;

  if (totalCount > exportQuery.pageSize) {
    const totalPages = Math.ceil(totalCount / exportQuery.pageSize);
    for (let page = 1; page < totalPages; page++) {
      const { data: pageData } = await fetchData({
        query: { ...exportQuery, page }
      });
      if (!isUndefined(pageData)) {
        allData = [...allData, ...pageData];
      }
    }
  }

  const mappedData = mapData ? allData.map(mapData) : allData;

  const visibleFields = new Set(
    dataManager.columns.filter(col => !col.hidden).map(col => col.field)
  );

  const headers = csvHeaders
    .filter(h => visibleFields.has(h.key))
    .map(h => ({ title: h.label, field: h.key }));

  return ExportCsv(headers, mappedData, filename, ';');
};

export default exportTableDataCsv;
